module.exports = "/assets/1f4c2a1a35383a3afd5aa7dda0162004.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5R.png
// module id = 1069
// module chunks = 0